import React, { MouseEventHandler } from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/RejectedClaimsPage/messages';
import { Config } from 'containers/AppContainer/typings';
import { getRejectionReasons } from 'containers/RejectedClaimsPage/utils';
import { isEmpty, uniqueId } from 'lodash';
import { Container } from 'containers/RejectedClaimsPage/styled-components';

export interface RejectedReasonsDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  otherRejectionReason: string;
  rejectionReasons: { rejectionReasonId: number }[];
  rejectionReasonsListing: Config[];
}

const RejectedReasonsDrawer: React.FC<RejectedReasonsDrawerProps> = (
  props,
): JSX.Element => {
  const rejectionReasons = getRejectionReasons(
    props.rejectionReasonsListing,
    props.rejectionReasons,
  );

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.rejectedReasonsDrawerTitle }, props)}
      handleValidateDrawer={props.handleToggleDrawer as MouseEventHandler}
      confirmButtonTitle={translate({ ...messages.confirmButton }, props)}
      isDisplayCancelButton={false}
    >
      <Container>
        {!isEmpty(rejectionReasons) &&
          rejectionReasons.map(reason => (
            <span key={uniqueId('reason')}>- {reason}</span>
          ))}
        <div className="other-reason">
          <span>{props.otherRejectionReason}</span>
        </div>
      </Container>
    </SahamDrawer>
  );
};

export default injectIntl(RejectedReasonsDrawer);
